// Track List Preview

TrackListPreview = function (_settings) {
    this.create(_settings || {});
};
TrackListPreview.prototype = {
    create: function(_settings) {
        this.settings = _settings;
        this.element = this.settings.element;
        this.roles = this.settings.roles;
        this.compose();
        this.onRefresh = this.settings.onRefresh;
        if (_settings.tracks) {
            this.onData(this.settings.tracks);
            delete(this.settings.tracks);
        } else {
            this.refresh();
        }
    },
    compose: function() {
        this.element.append("\
        \<div id=\"analysis_details\"></div>\
<table>\
  <tr>\
    <th></th>\
    <th></th>\
    <th>" + _T('isrc_code') + "</th>\
    <th>" + _T('track title') + "</th>\
    <th>" + _T('track artists') + "</th>\
    <th>" + _T('Analysis') + "</th>\
    <th>" + _T('parental advisory') + "</th>\
    <th>" + _T('time') + "</th>\
    <th></th>\
  </tr>\
</table>");
    },
    refresh: function() {
        var self = this;
        $.get(this.settings.url)
            .done(function(_data) { self.onData(_data); });
        this.onRefresh ? this.onRefresh() : null;
    },
    audioHasIssues: function(audio) {
        if(audio.length == 0
            || audio.original.length == 0
            || audio.original.analysis.length == 0) {
            return false;
        }

        if( audio.original.analysis.length > 0 ) {
            analysis =  audio.original.analysis[0];
            if(audio.original.analysis[0].has_issues == 1) {
                return true;
            }
        }
    },
    onData: function(_data) {
        var table = this.element.find('table');
        table.find('tr:not(:first)').remove();

        if (_data.length == 0) {
            table.append('<tr><td colspan="6">' + _T('no tracks found') + '</td></tr>');
            return;
        }

        var self = this;
        _.each(_data, function(_item) {
            const track = _item.track;
            let hasIssues = self.audioHasIssues(track.audio);

            table.append("\
<tr id='row_track_" + track.id + "'>\
  <td>" + (track.audio.full ? '<a class="icon play" href="#" />' : '') + "</td>\
  <td>" + _item.track_no + "</td>\
  <td>" + (track.isrc ? track.isrc : (track.assign_isrc ? "auto" : "&#x2014;")) + "</td>\
  <td class='track_title'><div style='width: fit-content;'><a data-track_id='" + track.id + "' href='#' class='edit_track edit__track'>" + track.title + "</a></div><div style='width: fit-content;'>" + (track.remix_or_version ? '[' + track.remix_or_version + ']' : '—') + "</div></td>\
  <td class='track_artists' data-track_id='" + track.id + "'><div style='width: fit-content;'>" + (track.display_artist ? track.display_artist : '—') + "</div></td>\
  <td class='track_analysis'>" + (hasIssues ? "<a class=\'track_analysis\' data-track_id='" + track.id + "' href='#'><img src = \"/images/default/analysis.png\"/></a>" : '') + "</tdclass>\
  <td class='track_explicit'><div>" + (track.explicit_language ? _T(track.explicit_language + '_content') : _T('')) + "</div></td>\
  <td>" + (track.audio.original ? getTime(Math.floor(track.audio.original.time), true) : _T('no audio')) + "</td>\
  <td style='display: flex; justify-content: flex-end;'><button style='min-width: fit-content; 'class='edit_track col-1 button button--l button__primary ui-button ui-corner-all ui-widget clarity-trackeable' data-track_id='" + track.id + "' href='#'>" + _T('edit') + "</button></td>\
</tr>");

            if (track.audio.full) {
                table.find('#row_track_' + track.id + ' > td > a.icon.play').data('track_element', track);
            }

            var artistsRoles = new ArtistsRoles(track.artists, self.roles, ['1']);
            $('.track_artists[data-track_id=' + track.id + ']').append(artistsRoles.namesByRolesToHTML());

        });

        table.on('click', '.edit_track' , function() {
            self.loadTrack(this.dataset.track_id);
            return false;
        });

        table.on('click', 'a.track_analysis', function(e) {
            e.preventDefault();
            $.ajax('/api/1.0/tracks/' + this.dataset.track_id)
                .done(function(_data) {
                    if(_data.audio.original.analysis.length > 0) {
                        const audioAnalysisDetailsDialog = new AudioAnalysisDetailsDialog({
                            container: $('#analysis_details'),
                            initial: _data.audio.original.analysis[0],
                            track_title: _data.title
                        })
                        audioAnalysisDetailsDialog.show();
                    }
                });
        });

        table.on('click', '.icon.play', function(e) {
            e.preventDefault();
            var track = $(this).data('track_element');
            if (track) {
                app.player.addTrack(track);
            }
            return false;
        });
    },
    loadTrack: function(_id, _tab) {
        var self = this;
        var dialog = $('#track_dialog');

        $.ajax('/tracks/' + _id + (_tab ? '/' + _tab : ''), { headers: { 'x-mx2-layout':'content-area' }})
            .done(function(_data) {
                var id = 'track_' + _id;

                dialog.html(_data).dialog({
                    buttons: [{
                        text: _T('cancel'),
                        id: 'track_dialog_cancel',
                        class: 'button__primary--ghost button__make-up',
                        click: function() {
                            dialog.dialog('close');
                        }
                    },{
                        text: _T('save'),
                        id: 'track_dialog_save',
                        class: 'success button__make-up',
                        click: function() {
                            trackEd.save();
                        }
                    }
                    ],
                    open: function() {
                        var buttonPane = dialog.parent().find('.ui-dialog-buttonset');

                        if (!buttonPane.find('.dialog-button-container').length) { 
                            buttonPane.wrapInner('<div class="dialog-button-container"></div>');

                            buttonPane.css({
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%',
                                marginBottom: '30px',
                            });
                            $('.dialog-button-container').css({
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '24px',
                                maxWidth: '718px',
                                width: '100%',
                                padding: '16px',
                            });
                        }

                        var header = dialog.parent().find('.ui-dialog-titlebar');
                        if (!header.find('.dialog-header-container').length) { 
                            header.wrapInner('<div class="dialog-header-container"></div>');
                            header.css({
                                position: 'fixed',
                                width: '100%',
                                zIndex: 999,
                                top: 0,
                                left: 0,
                                padding: '8px 16px',
                                border: 'none',
                                borderBottom: '1px solid #dddddd',
                            });
                            $('.dialog-header-container').css({
                                position: 'relative',
                                display: 'flex',
                                height: '28px'
                            });
                        }
                    },
                    close: function() {
                        // Block the warning when trying to navigate away from the page
                        // Not done with disableUnsavedChangesWarning so that the warning will still show when the dialog is open
                        trackEd.isDirty = false;

                        dialog.html("");
                    },
                    modal: true,
                    position: { at: 'top+96' },
                    width: '100%',
                    title: 'Edit track' });

                postRender();
                dialog.on('click', '.item_tab a', function() {
                    self.loadTrack(this.dataset.track_id, this.dataset.track_action);
                    return false;
                });

                return false;
            });

        return false;
    }
};

// Audio Metadata

AudioMetadata = function (_settings) {
    this.create(_settings || {})
};
AudioMetadata.prototype = {
    create:function (_settings) {
        this.settings = _settings;
        this.id = _settings.id;
        this.audio_type = _settings.type;
        this.created_at = _settings.created_at;
        this.compose();

        if (this.settings.data == undefined) {
            this.reload();
        } else {
            this.onData(this.settings.data);
        }
    },
    compose:function () {
        this.title = $('<b></b>').html(this.audio_type);
        this.link = $('<a href="#" class="icon play"></a>').hide();
        this.download = $('<a rel="external" href="#" class="icon download"></a>')
        this.content = $('<td></td>');
        this.settings.container.html('');
        this.settings.container
            .append($('<table></table>')
                .append($('<tr></tr>')
                    .append($('<td style="width:16px"></td>').append(this.link))
                    .append($('<td style="width:16px"></td>').append(this.download))
                    .append($('<td></td>').css('width', '10em').append(this.title))
                    .append(this.content))
            );
    },
    setId:function (_id) {
        this.id = _id;
        this.reload();
    },
    reload:function () {
        var self = this;
        $.get('/api/1.0/audio_files/' + this.id).done(function(_data) { self.onData(_data); });
    },
    onData:function (_data) {
        this.data = _data;
        this.render();
    },
    render: function () {
        var str = this.data.metadata.format_name + ' ' + getTime(this.data.time, true) + ' (' + bytesToHuman(this.data.metadata.filesize) + '), ';
        if (this.data.type == 1) {
            this.link.hide();
            str += ' ' + this.data.bits_per_sample + ' bits ' + this.data.sample_rate + ' Hz ' + this.data.metadata.channelmode.toUpperCase();
        } else {
            var self = this;
            this.link.bind('click', function (e) {
                e.preventDefault();
                app.player.addTrack(self.settings.audio_item);
            });
            this.link.show();
        }
        str += ' ' + Math.round(this.data.metadata.avg_bit_rate / 1024) + ' kbps ' + this.data.metadata.bitrate_mode.toUpperCase();

        if (this.audio_type == 'original') {
            str += ' ' + _T('uploaded at %s', this.created_at);
        }

        this.content.html(str);
        this.download.attr('href', this.data.url);
    }
};

// Item Audio Info

ItemAudioInfo = function (_settings) {
    this.create(_settings || {});
};
ItemAudioInfo.prototype = {
    create:function (_settings) {
        this.settings = _settings;
        this.info = [];

        if (this.settings.initial == undefined) {
            this.reload();
        } else {
            this.onData(this.settings.initial);
            delete(this.settings.initial);
        }
    },
    reload:function () {
        var self = this;
        $.get(this.settings.endpoint).done(function(_data) { self.onData(_data); });
    },
    getFiles: function() {
        return this.data;
    },
    onData:function (_data) {
        this.data = _data;
        this.settings.container.html('');
        for (var j in this.data) {
            if (this.info[ j ]) {
                this.info[ j ].setId(this.data[ j ].id);
            } else {
                var c = $('<div></div>');
                this.settings.container.append(c);
                var am = new AudioMetadata({
                    id:this.data[ j ].id,
                    url:this.data[ j ].url,
                    audio_item:this.settings.audio_item,
                    type:j,
                    container:c,
                    created_at:this.data[ j ].created_at,
                    data: this.data[ j ]
                });
                this.info[ j ] = am;
            }
        }
        if (this.settings.afterData) {
            this.settings.afterData(_data);
        }
    }
};

//usage report detail
UsageReportDetail = function (_settings) {
    this.create(_settings || {});
};
UsageReportDetail.prototype = {
    create: function (_settings) {
        this.settings = _settings;
        this.container = $('#' + _settings.id);

        this.onData(this.settings.current);
    },
    onData: function (_data) {
        if (this.report = _data) {
            this.render();
        } else {
            this.renderEmpty();
        }
    },
    renderEmpty: function () {
        this.container.empty();
        this.container.append($('<p>' + _T('There are no usage statements for this period') + '.</p>'));
    },
    render: function () {
        var end_date = this.report.closed_at === null ? moment().endOf('month') : moment(this.report.to);

        var dates = $('<p>' + _T('The statement period for this report is %s - %s', [moment(this.report.from).format(DATE_FORMAT_ISO_DATE), end_date.format(DATE_FORMAT_ISO_DATE)]) + '.</p>');

        if (!this.report.closed_at) {
            dates.append(
                $('<p>' + _T('This period is still open and the charges on this page currently show activity through approximately %s', moment(this.report.updated_at).format(DATE_FORMAT_ISO_TIMESTAMP)) + '.</p>')
            );
        }

        var detail = $("\
            <table>\
                <thead>\
                    <tr>\
                        <th style='display: min-width: 250px;'>" + _T('service') + "</th>\
                        <th style='min-width: 80px'>" + _T('unit') + "</th>\
                        <th colspan='2' style='min-width: 90px'>" + _T('units') + "</th>\
                        <th class='amount' style='min-width: 90px'>" + _T('p_u') + "</th>\
                        <th class='amount' style='min-width: 80px'>" + _T('total') + "</th>\
                    </tr>\
                </thead>\
            </table>");

        var body = $('<tbody></tbody>');

        var self = this;

        // Services
        _.each(this.report.report.services, function (_service) {
            _.each(add_units_interval(_service.details), function (_band, _key) {
                var final_amount = round_to_fixed(_band.price_u, 1 * self.settings.currency.e + 2) + self.settings.currency.symbol;
                if (_service.unit === 'eur') {
                    var final_amount = _band.price_u * 100 + '%';
                }
                var line = $("\
<tr class='item'>\
    <td>" + (_key == 0 ? _T('service_' + _service.service) : '') + "</td>\
    <td>" + _service.unit + "</td>\
    <td>" + _band.units + "</td>\
    <td>" + (_.size(_service.details) > 1 ? '(' + _band.units_from + ' - ' + _band.units_to + ')' : '') + "</td>\
    <td class='amount'>" + final_amount + "</td>\
    <td class='amount'>" + round_to_fixed(_band.units * _band.price_u, self.settings.currency.e) + self.settings.currency.symbol + "</td>\
</tr>");
                body.append(line);
            });
            if (_.size(_service.details) > 1) {
                body.append($("\
<tr class='subtotal'>\
    <td colspan='6' class='amount'>" + round_to_fixed(_service.amount, self.settings.currency.e) + self.settings.currency.symbol + "</td>\
</tr>"));
            }
        });

        // Fixed costs
        _.each(this.report.report.options, function(_option) {
            var line;

            if (_option.type == 'monthly_fee') {
                line = $("\
<tr class='item'>\
    <td>" + _T('tenant_usage_option_' + _option.type) + "</td>\
    <td>—</td>\
    <td>" + _T('tenant_level_' + _option.tenant_level_name) + "</td>\
    <td></td>\
    <td>—</td>\
    <td class='amount'>" + round_to_fixed(_option.amount, self.settings.currency.e) + self.settings.currency.symbol + "</td>\
</tr>");
            } else if (_option.type = 'support_level') {
                line = $("\
<tr class='item'>\
    <td>" + _T('tenant_usage_option_' + _option.type) + "</td>\
    <td>—</td>\
    <td>" + _T('support_level_' + _option.support_level_name) + "</td>\
    <td></td>\
    <td>—</td>\
    <td class='amount'>" + round_to_fixed(_option.amount, self.settings.currency.e) + self.settings.currency.symbol + "</td>\
</tr>");
            }
            body.append(line);
        });

        // Discounts

        _.each(this.report.report.discounts, function (_discount) {
            _.each(add_units_interval(_discount.details), function (_band, _key) {

                //TODO: (2022-05-03) Let's assume that the discounts are, for now, all in %
                var final_amount = _band.price_u * -100 + '%';

                var line = $("\
<tr class='item'>\
    <td>" + _T(_discount.type) + "</td>\
    <td>" + _discount.unit + "</td>\
    <td>" + _discount.units + "</td>\
    <td></td>\
    <td class='amount'>" + final_amount + "</td>\
    <td class='amount'>" + _discount.amount + self.settings.currency.symbol + "</td>\
</tr>");
                body.append(line);
            });
        });

        function periodInformation(value) {
            return value.slice(-7);
        }


        // Penalties
        _.each(this.report.report.penalties, function (penalty) {
            var line = $("\
                <tr class='item'>\
                  <td>" + _T('service_' + penalty.service) + "</td>\
                  <td>" + penalty.unit.toLowerCase()  + "</td>\
                  <td colspan='3'>" + _T('period_information') + ': ' + periodInformation(penalty.description) + "</td>\
                  <td class='amount'>" + round_to_fixed(penalty.amount, self.settings.currency.e) + self.settings.currency.symbol + "</td>\
                </tr>");
            body.append(line);
        });


        // Taxes

        body.append($("\
<tr class='subtotal'>\
    <td colspan='5'>" + _T('total before taxes') + "</td>\
    <td>" + round_to_fixed(this.report.amount_before_taxes, this.settings.currency.e) + this.settings.currency.symbol + "</td>\
</tr>"));

        _.each(
            this.report.report.taxes,
            function (tax) {
                body.append($("\
<tr class='subtotal'>\
    <td colspan='5'>" + _T(tax.tax_name) + ' ' + round_to_fixed(tax.rate, 2) + "</td>\
    <td>" + round_to_fixed(tax.amount, this.settings.currency.e) + this.settings.currency.symbol + "</td>\
</tr>"));
            },
            this
        );

        // Total

        body.append($("\
<tr class='total'>\
    <td colspan='5'>" + _T('total') + "</td>\
    <td>" + round_to_fixed(this.report.amount_after_taxes, this.settings.currency.e) + this.settings.currency.symbol + "</td>\
</tr>"));

        detail.append(body);

        this.container.empty();
        this.container.append(dates);
        this.container.append(detail);
    }
};